/**
 * @file index.js
 * @description Entry point for the E-Operations web portal.
 * 
 * @project E-Operations
 * @version 1.0.0
 * @license PITC
 * @author Muhammad Ammad
 */

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import { persistor, store } from "./store";
import { PersistGate } from "redux-persist/integration/react";
import { pruneStaleStorage } from "./utils/pruneStaleStorage";
import { installFetchNetworkInterceptor } from "./utils/networkConnectivity";
import "./style/appTheme.scss";

pruneStaleStorage();
installFetchNetworkInterceptor();

// ✅ Inject Nunito font dynamically
const fontLink = document.createElement("link");
fontLink.href = "https://fonts.googleapis.com/css2?family=Nunito:wght@200;300;400;500;600;700;800;900&display=swap";
fontLink.rel = "stylesheet";
document.head.appendChild(fontLink);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate
      loading={
        <div
          style={{ minHeight: "100vh", backgroundColor: "#F3F6FB" }}
          aria-busy="true"
        />
      }
      persistor={persistor}
    >
      <App />
    </PersistGate>
  </Provider>
);
